/**
 * Consent-Status der DCCookie-Provider.
 *
 * DCCookie legt die Provider mitsamt ihrem State als JSON im localStorage ab
 * (siehe CookieHelper.setDCCookieProviderStates im Plugin DCcookie). Eine
 * offizielle JS-API gibt es nicht - window.dcCookie haelt die Helper nur lokal
 * in init(). Deshalb lesen wir den State direkt aus dem Storage.
 */
const PROVIDER_STORAGE_KEY = 'dcCookieProvider';

/**
 * @param {string} providerId - provider_id aus dem CMS, z.B. "hubspot"
 * @returns {boolean} true, wenn der Nutzer diesem Provider zugestimmt hat
 */
export function hasCookieConsent(providerId) {
    try {
        const raw = localStorage.getItem(PROVIDER_STORAGE_KEY);
        if (!raw) return false;

        const providers = JSON.parse(raw);
        return Array.isArray(providers)
            && providers.some(provider => provider.id === providerId && provider.state === true);
    } catch {
        // Kein bzw. kaputter localStorage: im Zweifel kein Consent.
        return false;
    }
}

/**
 * Ruft onConsent auf, sobald der Provider freigegeben ist - sofort, wenn die
 * Zustimmung schon vorliegt, sonst beim Zustimmen.
 *
 * Als Trigger dient das DOM: DCCookie leert bei Zustimmung den
 * externalMediaContainer (CookieHelper.doCookieAction) und ersetzt DIVs mit der
 * iframeclass durch echte iframes (CookieHelper.replaceElementTag). Beides
 * passiert innerhalb von root, also genuegt ein MutationObserver darauf.
 *
 * @param {string} providerId
 * @param {HTMLElement} root - Bereich, in dem DCCookie die Container austauscht
 * @param {Function} onConsent
 * @returns {Function} Abmeldefunktion
 */
export function onCookieConsent(providerId, root, onConsent) {
    if (hasCookieConsent(providerId)) {
        onConsent();
        return () => {};
    }

    const observer = new MutationObserver(() => {
        if (!hasCookieConsent(providerId)) return;

        // Vor dem Callback abmelden, damit dessen eigene DOM-Aenderungen
        // den Observer nicht erneut ausloesen.
        observer.disconnect();
        onConsent();
    });

    observer.observe(root, { childList: true, subtree: true });

    return () => observer.disconnect();
}
